import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SportIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12.0001 18.5996C15.6452 18.5996 18.6001 15.6447 18.6001 11.9996C18.6001 8.35453 15.6452 5.39961 12.0001 5.39961C8.35502 5.39961 5.4001 8.35453 5.4001 11.9996C5.4001 15.6447 8.35502 18.5996 12.0001 18.5996ZM12.0001 20.3996C16.6393 20.3996 20.4001 16.6388 20.4001 11.9996C20.4001 7.36042 16.6393 3.59961 12.0001 3.59961C7.36091 3.59961 3.6001 7.36042 3.6001 11.9996C3.6001 16.6388 7.36091 20.3996 12.0001 20.3996Z"
      />
      <path
        fillRule="evenodd"
        d="M16.7649 5.08105C17.2613 5.42362 17.7191 5.81825 18.1303 6.25704L18.7121 8.04741L16.1887 9.88072L13.6654 8.04741L14.6292 5.08105H16.7649ZM5.61925 6.5364C6.09069 5.98633 6.63201 5.49793 7.22947 5.08496L9.20987 5.08496L10.1737 8.05132L7.65036 9.88463L5.12703 8.05132L5.61925 6.5364ZM20.0793 14.3065C20.13 14.1285 20.175 13.9481 20.2141 13.7655L19.3667 11.1576L16.2477 11.1576L15.2839 14.1239L17.8072 15.9573L20.0793 14.3065ZM3.73389 13.5018C3.79114 13.8189 3.8662 14.1299 3.95799 14.4336L6.05506 15.9573L8.5784 14.1239L7.61457 11.1576L4.49556 11.1576L3.73389 13.5018ZM11.9323 8.99827L14.4556 10.8316L13.4918 13.7979H10.3728L9.40893 10.8316L11.9323 8.99827ZM12.1139 20.3987L14.6372 18.5653L13.6734 15.599H10.5544L9.59057 18.5653L12.1139 20.3987Z"
      />
    </SvgIcon>
  );
});
